export const AVATAR_COLORS = [
  '#e74c3c','#e67e22','#f39c12','#27ae60','#16a085',
  '#2980b9','#8e44ad','#2c3e50','#d35400','#c0392b',
];

export function avatarColor(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export function initials(name) {
  return name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
}

export function fmtAmount(n) {
  return '₹' + Math.abs(n).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

export function fmtDate(d) {
  if (!d) return '';
  const dt = new Date(d + 'T00:00:00');
  return dt.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function today() {
  return new Date().toISOString().split('T')[0];
}

export function PartyAvatar({ name, size = 40 }) {
  const color = avatarColor(name);
  const init = initials(name);
  return (
    <div className="party-avatar" style={{ width: size, height: size, background: color, fontSize: size * 0.375 }}>
      {init}
    </div>
  );
}
